import {TouchEvent, useCallback, useEffect, useRef, useState} from "react";

import {BOTTOM_SHEET_CLOSE_MS} from "../constants/bottom_sheet";

const DEFAULT_DISMISS_THRESHOLD_PX = 40;

interface IOptions {
    enabled?: boolean;
    thresholdPx?: number;
    settleMs?: number;
}

export const useSwipeToDismiss = (onDismiss: () => void, options: IOptions = {}) => {
    const {enabled = true, thresholdPx = DEFAULT_DISMISS_THRESHOLD_PX, settleMs = BOTTOM_SHEET_CLOSE_MS} = options;

    const startYRef = useRef<number | null>(null);
    const offsetYRef = useRef(0);
    const settleTimeoutRef = useRef<number>(0);
    const settleFrameRef = useRef<{outer: number; inner: number}>({outer: 0, inner: 0});
    const [offsetY, setOffsetY] = useState(0);
    const [isSettling, setIsSettling] = useState(false);

    const clearSettleTimers = useCallback(() => {
        window.cancelAnimationFrame(settleFrameRef.current.outer);
        window.cancelAnimationFrame(settleFrameRef.current.inner);
        window.clearTimeout(settleTimeoutRef.current);
        settleFrameRef.current = {outer: 0, inner: 0};
        settleTimeoutRef.current = 0;
    }, []);

    useEffect(() => () => clearSettleTimers(), [clearSettleTimers]);

    const resetOffset = useCallback(() => {
        clearSettleTimers();
        offsetYRef.current = 0;
        setOffsetY(0);
        setIsSettling(false);
    }, [clearSettleTimers]);

    const settleOffset = useCallback(() => {
        if (offsetYRef.current === 0) {
            setIsSettling(false);
            return;
        }

        clearSettleTimers();
        setIsSettling(true);

        settleFrameRef.current.outer = window.requestAnimationFrame(() => {
            settleFrameRef.current.inner = window.requestAnimationFrame(() => {
                offsetYRef.current = 0;
                setOffsetY(0);
            });
        });

        settleTimeoutRef.current = window.setTimeout(() => {
            setIsSettling(false);
        }, settleMs);
    }, [clearSettleTimers, settleMs]);

    const onTouchStart = (event: TouchEvent) => {
        if (!enabled) return;

        clearSettleTimers();
        setIsSettling(false);
        startYRef.current = event.touches[0].clientY;
    };

    const onTouchMove = (event: TouchEvent) => {
        if (!enabled || startYRef.current == null) return;

        const nextOffsetY = Math.max(0, event.touches[0].clientY - startYRef.current);
        offsetYRef.current = nextOffsetY;
        setOffsetY(nextOffsetY);
    };

    const onTouchEnd = () => {
        if (!enabled) return;

        const shouldDismiss = offsetYRef.current >= thresholdPx;
        startYRef.current = null;

        if (shouldDismiss) {
            // Keep offset so close animation continues from the drag position (no jump).
            onDismiss();
            return;
        }

        settleOffset();
    };

    return {
        isSettling,
        offsetY,
        offsetYRef,
        resetOffset,
        swipeHandlers: {
            onTouchStart,
            onTouchMove,
            onTouchEnd
        }
    };
};
import {TouchEvent, useCallback, useEffect, useRef, useState} from "react";

import {BOTTOM_SHEET_CLOSE_MS} from "../constants/bottom_sheet";

const DEFAULT_DISMISS_THRESHOLD_PX = 40;

interface IOptions {
    enabled?: boolean;
    thresholdPx?: number;
    settleMs?: number;
}

export const useSwipeToDismiss = (onDismiss: () => void, options: IOptions = {}) => {
    const {enabled = true, thresholdPx = DEFAULT_DISMISS_THRESHOLD_PX, settleMs = BOTTOM_SHEET_CLOSE_MS} = options;

    const startYRef = useRef<number | null>(null);
    const offsetYRef = useRef(0);
    const settleTimeoutRef = useRef<number>(0);
    const settleFrameRef = useRef<{outer: number; inner: number}>({outer: 0, inner: 0});
    const [offsetY, setOffsetY] = useState(0);
    const [isSettling, setIsSettling] = useState(false);

    const clearSettleTimers = useCallback(() => {
        window.cancelAnimationFrame(settleFrameRef.current.outer);
        window.cancelAnimationFrame(settleFrameRef.current.inner);
        window.clearTimeout(settleTimeoutRef.current);
        settleFrameRef.current = {outer: 0, inner: 0};
        settleTimeoutRef.current = 0;
    }, []);

    useEffect(() => () => clearSettleTimers(), [clearSettleTimers]);

    const resetOffset = useCallback(() => {
        clearSettleTimers();
        offsetYRef.current = 0;
        setOffsetY(0);
        setIsSettling(false);
    }, [clearSettleTimers]);

    const settleOffset = useCallback(() => {
        if (offsetYRef.current === 0) {
            setIsSettling(false);
            return;
        }

        clearSettleTimers();
        setIsSettling(true);

        settleFrameRef.current.outer = window.requestAnimationFrame(() => {
            settleFrameRef.current.inner = window.requestAnimationFrame(() => {
                offsetYRef.current = 0;
                setOffsetY(0);
            });
        });

        settleTimeoutRef.current = window.setTimeout(() => {
            setIsSettling(false);
        }, settleMs);
    }, [clearSettleTimers, settleMs]);

    const onTouchStart = (event: TouchEvent) => {
        if (!enabled) return;

        clearSettleTimers();
        setIsSettling(false);
        startYRef.current = event.touches[0].clientY;
    };

    const onTouchMove = (event: TouchEvent) => {
        if (!enabled || startYRef.current == null) return;

        const nextOffsetY = Math.max(0, event.touches[0].clientY - startYRef.current);
        offsetYRef.current = nextOffsetY;
        setOffsetY(nextOffsetY);
    };

    const onTouchEnd = () => {
        if (!enabled) return;

        const shouldDismiss = offsetYRef.current >= thresholdPx;
        startYRef.current = null;

        if (shouldDismiss) {
            // Keep offset so close animation continues from the drag position (no jump).
            onDismiss();
            return;
        }

        settleOffset();
    };

    return {
        isSettling,
        offsetY,
        offsetYRef,
        resetOffset,
        swipeHandlers: {
            onTouchStart,
            onTouchMove,
            onTouchEnd
        }
    };
};
